import React, { Component } from 'react';
import { Redirect } from "react-router";
import { withTranslation } from "react-i18next";
import Loading from "./Parts/Loading";
import ErrorAlert from "../../components/UI/ErrorAlert";

class InitIndivyPlanProcess extends Component {
    constructor(props) {
        super(props);

        const { match: { params } } = this.props;

        this.state = {
            token: params.token,
            loadingContactsForm: true,
            redirectToContactsStep: false,
        };

        // Load and cache data (DB)
        axios.get('/api/process/' + params.token + '/info', {
            params: {step: 'contacts'}
        })
            .then(
                data => {
                    this.setState({
                        loadingContactsForm: false,
                        redirectToContactsStep: true
                    });
                },
                error => {
                    this.setState({ loadingContactsForm: false });
                }
            )
    }

    render() {
        if (this.state.redirectToContactsStep) {
            return <Redirect to={{ pathname: '/' + this.state.token + '/process/contacts' }} />
        }

        return (
            <div>

                <div className="container">
                    <ErrorAlert/>
                </div>

                {this.state.loadingContactsForm &&
                    <div className="row py-5">
                        <div className="container frame py-5">
                            <Loading
                                msg={this.props.t('waiting_for_eshop_data')}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default withTranslation()(InitIndivyPlanProcess);
